import React from 'react';

export default function DeltaPriceCell(cellData) {
    if (cellData.value > 0) {
        return (
            <div className="deltaPosPrice"><span className="deltaPriceIcon dx-icon-sortup"/>+{cellData.value.toFixed(2)}</div>
        );
    }

    if (cellData.value < 0) {
        return (
            <div className="deltaNegPrice"><span className="deltaPriceIcon dx-icon-sortdown" />{cellData.value.toFixed(2)}</div>
        );
    }

    return (
        <div className="deltaPrice">{cellData.value}</div>
    );
}


// WEBPACK FOOTER //
// ./App/containers/position/DeltaPriceCell.jsx